export default "__VITE_ASSET__16c50e74__"